import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const deleteBannerFunc = createAsyncThunk(
  "deleteBanner",
  async (id, thunkAPI) => {
    try {
      const response = await api.delete(`dashboard/general-settings/banners/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const deleteBannerSlicer = createSlice({
  name: "deleteBanner",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteBannerFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(deleteBannerFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(deleteBannerFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});
export default deleteBannerSlicer.reducer;
